export default "<div #blockly style=\"width: 100%;\"></div>\n\n"